/* ============================================================
   PRIME ORGANICS | the offer, in one place

   Consumed by all three antibiotic-angle listicles (editorial,
   brief, countdown). Prices, tier math and the product link live
   here and nowhere else.

   DOM-free on purpose: no selectors, no listeners, no side effects
   beyond defining window.PO_OFFER.

   Base price read off the live store's public products.json on
   2026-08-05: vaginal-probiotic, one variant (42746987577419),
   $32.99, no compare_at. The 2 and 3 bottle percentages are
   PROPOSALS priced off that real base. The store has no bundle
   variants, so no CTA here pretends to add a discounted bundle to
   a cart; every CTA links to the live PDP instead.
   ============================================================ */
(() => {
  const PRICE_CENTS = 3299;

  const money = c => '$' + (c / 100).toFixed(2);

  /* 60 vegan capsules, 2 daily = 30 days per bottle. */
  const DAYS_PER_BOTTLE = 30;

  const TIERS = [
    { qty: 1, pct: 0,  tag: 'Single bottle',  days: 30 },
    { qty: 2, pct: 15, tag: 'Recovery pair',  days: 60 },
    { qty: 3, pct: 25, tag: 'Full rebuild',   days: 90 },
  ].map(t => {
    const full = PRICE_CENTS * t.qty;
    const total = Math.round(full * (100 - t.pct) / 100);
    return {
      ...t,
      fullCents: full,
      totalCents: total,
      eachCents: Math.round(total / t.qty),
      saveCents: full - total,
      perDayCents: Math.round(total / (t.qty * DAYS_PER_BOTTLE)),
    };
  });

  window.PO_OFFER = {
    product: {
      title: 'Prime Organics Vaginal Probiotic',
      handle: 'vaginal-probiotic',
      variantId: 42746987577419,
      priceCents: PRICE_CENTS,
      capsules: 60,
      capsPerDay: 2,
      daysPerBottle: DAYS_PER_BOTTLE,
      url: 'https://mbs3ew-s6.myshopify.com/products/vaginal-probiotic',
    },
    tiers: TIERS,
    money,
  };
})();
